function formIframeCallback(pCode, pFields){
	$(document).trigger('onIframeCallback', [pCode, pFields]);
}


$(document).on('ready', function(){
       
    FastClick.attach(document.body);
    
    /*** transitions FancyBox resizeIn ****/
    (function(f,b){b.transitions.resizeIn=function(){var c=b.previous,a=b.current,d=c.wrap.stop(!0).position(),e=f.extend({opacity:1},a.pos);d.width=c.wrap.width();d.height=c.wrap.height();c.wrap.stop(!0).trigger("onReset").remove();delete e.position;a.inner.hide();a.wrap.css(d).animate(e,{duration:a.nextSpeed,easing:a.nextEasing,step:b.transitions.step,complete:function(){b._afterZoomIn();a.inner.fadeIn("fast")}})}})(jQuery,jQuery.fancybox);
    
    
    $(document).on('click', '.menu-icon', function(e){
      $(this).toggleClass('open');
      $(this).parent().find('.menu-full-toggle-ul').toggleClass('open');
    });
    
    
    $(document).on('focus', 'input, textarea', function(e){
        var holder = $(this).attr("placeholder");
        var val = $(this).val();
        if(val == holder)$(this).val("");
    });

    $(document).on('blur', 'input', function(e){
        var holder = $(this).attr("placeholder");
        var val = $(this).val();
        if(val == "")$(this).val(holder);
    });
    
    
    $('.homepage-slider ul').bxSlider({ 
        controls : false, auto : true, autoStart : true, autoDelay : 2000,  pause : 6000, pager : false
    });
    
    
    $('.item-realisation').fancybox({
        padding : 10, margin:20,
        openEffect : 'fade', 
        closeEffect : 'fade', 
        nextMethod : 'resizeIn',
        prevEffect : 'resizeIn',
        nextSpeed  : 250,
        prevSpeed  : 250,
        
        helpers:  {
            title : {
                type : 'over'
            }
        },
        
        beforeShow : function() {
          this.href = $(this.element).find('a').attr('href');
          //this.title = $(this.element).find('.lgd').html();
          this.title = $(this.element).parents('.main-li-rea').find('.main-lgd').html();
        }/*,
        afterLoad  : function () {
          $.extend(this, {
              aspectRatio : false,
              type    : 'html',
              width   : '100%',
              height  : '100%',
              content : '<div class="my-fancy-image" style="background-image:url(' + this.href + '); background-size: cover; background-position:50% 50%;background-repeat:no-repeat;height:100%;width:100%;"></div>'
          });
            
        }*/  
    });

    
    
    
    $('a.fancybox').fancybox({
        padding : 0, margin:10,
        openEffect : 'fade', 
        closeEffect : 'fade', 
        nextMethod : 'resizeIn',
        prevEffect : 'resizeIn',
        nextSpeed  : 250,
        prevSpeed  : 250,
        maxWidth	: 1500,
		maxHeight	: 1000,
		fitToView	: false,
		width		: '90%',
		height		: '90%',
		autoSize	: false,
		closeClick	: false,
		openEffect	: 'none',
		closeEffect	: 'none',
        helpers:  {
            title : {
                type : 'over'
            }
        }
    });
    
        
        
       
    $(document).on('onIframeCallback', function(e, pCode, pFields){
         if(pCode == "error"){
             $("p.error-msg").fadeIn(250);
             window.formValidator.displayFormAfterVerifyFields("form", "error-field", pFields.fields, true);
         }else{
             $("p.error-msg").hide(); 
             $(".confirmation").show();
         }
     });
});



window.formValidator = {
    
    
    validateRegExp:function(pValue, pType){
        var reg;
        switch(pType){
            case 'mail':
                    reg  = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            break;

            case 'phone':
                    reg = /!^(\+){0,1}[0-9\/ \-\.]{8,25}$!/;
            break;

            default:
            break;

        }

        if(!is_string(pValue))return true;
        if(!reg)return true;
        if (pValue.match(reg))return true;
        return false;
    },

    verifyField:function(pValue, pType, pIsRequired){
        //valeur de code => ok, required, invalid, existing
        var code = "ok";

        if(pValue == ""){
            if(pIsRequired){
                code = "required";
            }
        }else{
            if(pType != ""){
                if(!this.validateRegExp(pValue, pType)){
                    code = "invalid";
                }
            }
        }
        return code;
    },

    verifyAllFieldsForm:function(pFields){

        var retour = {};
        var hasError = false;
        var msg = "";
        
        for(var field in pFields) { 
            var code = this.verifyField(pFields[field].value, pFields[field].type, pFields[field].required);
            if(code != "ok")hasError = true;
            retour[field] = {code:code, value:pFields[field].value};
        }
        return {fields:retour, hasError:hasError, msg:msg}; 
    },
    
    
    displayFormAfterVerifyFields:function(pSelecorJquery, pClassNameErrorField, pVerifyFields, pDisplayErrorForLabel){
        //pVerifyFields correspond au tableau de retour de la methode FORM_MANAGER.verifyField(pFields) :

        for(var field in pVerifyFields) { 
            this.displayFormElementByCode(pVerifyFields[field].code, pSelecorJquery + " #" + field, pClassNameErrorField);
            if(pDisplayErrorForLabel == true)this.displayFormElementByCode(pVerifyFields[field].code, pSelecorJquery + " label[for=" + field+"]", pClassNameErrorField);
        }
    },

    displayFormAllFieldsNoError:function(pSelecorJquery, pClassNameErrorField, pVerifyFields, pDisplayErrorForLabel){
        for(var field in pVerifyFields) { 
            $(pSelecorJquery + " #" + field).removeClass(pClassNameErrorField);
            if(pDisplayErrorForLabel == true)$( pSelecorJquery + " label[for=" + field+"]").removeClass(pClassNameErrorField);
        }
    },

    displayFormElementByCode:function(pCode, pSelecorJquery, pClassNameErrorField){
        if(pCode == "ok"){
            $(pSelecorJquery).removeClass(pClassNameErrorField);
        }else{
            $(pSelecorJquery).addClass(pClassNameErrorField);
        }
    } 

};


//# sourceMappingURL=bundle.js.map